import { createAction } from '@reduxjs/toolkit';

export const CHANGE_TEAM_SEARCH_FILTERS = createAction('reports/CHANGE_TEAM_SEARCH_FILTERS');

export const changeTeamFilters = (payload) => (dispatch) => {
  dispatch(CHANGE_TEAM_SEARCH_FILTERS(payload));
};
